export var OWA_AUTO_LINKS_CLASSNAME = 'OWAAutoLink';
// ClassName for links in the receiver side. This is for reply with original thread or forward.
export var X_OWA_AUTO_LINKS_CLASSNAME = 'x_OWAAutoLink';
export default function trySetIdAndClassName(anchorElement) {
    if (!anchorElement.id || anchorElement.id.length === 0) {
        anchorElement.id = Math.round(Math.random() * 1000000).toString();
    }
    if (anchorElement.className.indexOf(OWA_AUTO_LINKS_CLASSNAME) !== -1) {
        return;
    }
    if (anchorElement.className.length > 0) {
        anchorElement.className += ' ';
    }
    anchorElement.className += OWA_AUTO_LINKS_CLASSNAME;
}
//# sourceMappingURL=trySetIdAndClassName.js.map